import moment from 'moment';
import { CountryCode } from '../../index.js';
import { VoucherTypeIds } from '../vouchers/index.js';
import { calcCollectionCosts as calcCollectionCostsDK } from './collection-costs/denmark.js';
import { calcCollectionCosts as calcCollectionCostsGL } from './collection-costs/greenland.js';
export const getDeposits = (caseVouchers) => {
    return caseVouchers.filter((v) => {
        return v.voucherTypeId === VoucherTypeIds.DEPOSIT && v.amount !== 0;
    });
};
export const postProcessing = (caseVouchers, filter) => {
    let newCaseVouchers = [];
    for (const voucher of caseVouchers) {
        if (!filter.includeDeletedVouchers && voucher.deletedAt != null) {
            continue;
        }
        if (!filter.includeExpiredVouchers && voucher.expired) {
            continue;
        }
        if (!filter.includeIrrecoverableVouchers && voucher.irrecoverableDate) {
            continue;
        }
        if (voucher.expired || voucher.irrecoverableDate) {
            voucher.originalAmount = voucher.originalAmount || voucher.amount;
            voucher.amount = 0;
        }
        newCaseVouchers.push(voucher);
    }
    return newCaseVouchers;
};
export const isInsideTagInterval = (tag, date) => {
    const _date = moment(date);
    return (tag &&
        (!tag.from || moment(tag.from).isBefore(_date)) &&
        (!tag.to || moment(tag.to).isAfter(_date)));
};
export const calcCollectionCost = (caseVouchers, documents, expirationSettings, selfCollection, country) => {
    switch (country) {
        case CountryCode.GL: {
            return calcCollectionCostsGL(caseVouchers, documents, expirationSettings, selfCollection);
        }
        case CountryCode.DK: {
            return calcCollectionCostsDK(caseVouchers, documents, expirationSettings, selfCollection);
        }
        default: {
            return calcCollectionCostsDK(caseVouchers, documents, expirationSettings, selfCollection);
        }
    }
};
//# sourceMappingURL=vouchers.js.map